module.exports = __webpack_public_path__ + "img/ic_info_outline.7effffcc.svg";